export interface ITagsFilter {
  itemsByPage: number;
  pageIndex: number;
}

export type IItems = {
  id: number;
  locationDescription: string;
  readerNumber: string;
  readerName: string;
  readerIp: string;
  configId: string;
  modelDescription: string;
  port: string;
  protocol: string;
  status: boolean;
  antennas: Array<IDetailsItems>;
};

export type IDetailsItems = {
  readerLabel: string;
  antennaNumber: string;
  antennaDescription: string;
  sector: string;
  flow: string;
  antennaPort: string;
};

export type IReaderForm = {
  id: number;
  locationId: number;
  readerNumber: string;
  readerPositionType: number;
  readerIp: string;
  configId: string;
  modelType: number;
  port: number;
  protocol: string;
  status: boolean;
};

export type IAntennaForm = {
  id?: number;
  modelDescription: string;
  antennaNumber: number;
  antennaPositionType: number;
  sector: number;
  flow: number;
  serieNumber: string;
  model: string;
  antennaPort: number;
  status: boolean;
};

export type IForm = {
  reader: IReaderForm;
  antennas: Array<IAntennaForm>;
};

export interface IReadersState {
  isLoading: boolean;
  isLoadingTable: boolean;
  isLoadingForm: boolean;
  isLoadingDrawer: boolean;
  items?: Array<IItems>;
  totalItems: number;
  filter: ITagsFilter;
  searchFilter: string;
  visibleDrawer: boolean;
  visibleDeleteModal: boolean;
  form: IForm;
}

export const defaultState: IReadersState = {
  isLoading: false,
  isLoadingTable: false,
  isLoadingDrawer: false,
  isLoadingForm: false,
  visibleDrawer: false,
  visibleDeleteModal: false,
  form: {
    reader: {
      id: null,
      locationId: null,
      readerNumber: null,
      readerPositionType: null,
      readerIp: null,
      configId: null,
      modelType: null,
      port: null,
      protocol: null,
      status: false,
    },
    antennas: [],
  },
  items: [],
  totalItems: 0,
  searchFilter: "",
  filter: {
    itemsByPage: 10,
    pageIndex: 1,
  },
};
